'use client';

import React from 'react';
import { ArrowUpDown, GripVertical } from 'lucide-react';

interface ProductsGroupTabsProps {
  groupBy: 'CATEGORY' | 'BRAND';
  onGroupByChange: (mode: 'CATEGORY' | 'BRAND') => void;
  onViewAll: () => void;
  onReorderCategories?: () => void;
}

export default function ProductsGroupTabs({
  groupBy,
  onGroupByChange,
  onViewAll,
  onReorderCategories
}: ProductsGroupTabsProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pt-1 pb-1">
      {/* Pastillas de agrupación */}
      <div className="flex items-center gap-1.5">
        <button
          onClick={() => onGroupByChange('CATEGORY')}
          className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
            groupBy === 'CATEGORY'
              ? 'bg-slate-900 text-white shadow-sm'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          Por categoría
        </button>
        <button
          onClick={() => onGroupByChange('BRAND')}
          className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
            groupBy === 'BRAND'
              ? 'bg-slate-900 text-white shadow-sm'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          Por marca
        </button>
      </div>

      {/* Acciones del lado derecho: Ordenar categorías y Ver todos */}
      <div className="flex items-center gap-4 text-xs font-semibold text-slate-500">
        <button
          onClick={onReorderCategories}
          className="flex items-center gap-1 hover:text-slate-800 transition text-[11px]"
        >
          <GripVertical className="w-3.5 h-3.5 text-slate-400" />
          <span>Ordenar categorías</span>
        </button>

        <button
          onClick={onViewAll}
          className="hover:text-emerald-800 transition text-slate-600 hover:underline"
        >
          Ver todos
        </button>
      </div>
    </div>
  );
}
